export const jackpotGridEnum = {
	FANCY: 7,
	MULTIPLE_POOL: 8,
	SIMPLE: 9
} as const;

export const jackpotPoolCardPositions = {
	[jackpotGridEnum.FANCY]: {
		1: {
			small: `
				grid-column: 1;
				grid-row: 2;`,
			large: `
				grid-column: 1;
			`
		},
		2: {
			small: `
				grid-column: 1 / 3;
				grid-row: 1;`,
			large: `
				grid-column: 2;
			`
		},
		3: {
			small: `
				grid-column: 2;
				grid-row: 2;`,
			large: `
				grid-column: 3;
			`
		}
	},
	[jackpotGridEnum.MULTIPLE_POOL]: {
		1: {
			small: `
				grid-column: 1 / 3;
				grid-row: 1 / 3;`,
			large: `
				grid-column: 1 / 3;
				grid-row: 1 / 3;
			`
		},
		2: {
			small: `
				grid-column: 3 / 4;
				grid-row: 1;`,
			large: `
				grid-column: 3 / 4;
				grid-row: 1;`
		},
		3: {
			small: `
				grid-column: 3 / 4;
				grid-row: 2;`,
			large: `
				grid-column: 3 / 4;
				grid-row: 2;`
		}
	}
};

export const jackpotPoolCardSizes = {
	[jackpotGridEnum.FANCY]: {
		1: {
			small: `
				width: 162px;
				height: 162px;`,
			large: `
				width: 249px;
				height: 249px;`
		},
		2: {
			small: `
				width: 220px;
				height: 220px;`,
			large: `
				width: 249px;
				height: 249px;`
		},
		3: {
			small: `
				width: 162px;
				height: 162px;`,
			large: `
				width: 249px;
				height: 249px;`
		}
	},
	[jackpotGridEnum.MULTIPLE_POOL]: {
		1: {
			small: `
				width: 220px;
				height: 220px;`,
			large: `
				width: 336px;
				height: 336px;`
		},
		2: {
			small: `
				width: 104px;
				height: 104px;`,
			large: `
				width: 162px;
				height: 162px;`
		},
		3: {
			small: `
				width: 104px;
				height: 104px;`,
			large: `
				width: 162px;
				height: 162px;`
		}
	}
};

export const jackpotPoolAmountSizes = {
	[jackpotGridEnum.FANCY]: {
		1: {
			small: {
				withTimer: `height: 36px;`,
				noTimer: `height: 42px;`
			},
			large: {
				withTimer: `height: 45px;`,
				noTimer: `height: 60px;`
			}
		},
		2: {
			small: {
				withTimer: `height: 36px;`,
				noTimer: `height: 42px;`
			},
			large: {
				withTimer: `height: 45px;`,
				noTimer: `height: 60px;`
			}
		},
		3: {
			small: {
				withTimer: `height: 36px;`,
				noTimer: `height: 42px;`
			},
			large: {
				withTimer: `height: 45px;`,
				noTimer: `height: 60px;`
			}
		}
	},
	[jackpotGridEnum.MULTIPLE_POOL]: {
		1: {
			small: {
				withTimer: `height: 36px;`,
				noTimer: `height: 42px;`
			},
			large: {
				withTimer: `height: 45px;`,
				noTimer: `height: 60px;`
			}
		},
		2: {
			small: {
				withTimer: `height: 18px;`,
				noTimer: `height: 18px;`
			},
			large: {
				withTimer: `height: 42px;`,
				noTimer: `height: 42px;`
			}
		},
		3: {
			small: {
				withTimer: `height: 18px;`,
				noTimer: `height: 18px;`
			},
			large: {
				withTimer: `height: 42px;`,
				noTimer: `height: 42px;`
			}
		}
	},
	[jackpotGridEnum.SIMPLE]: {
		small: {
			withTimer: `height: 36px;`,
			noTimer: `height: 42px;`
		},
		large: {
			withTimer: `height: 45px;`,
			noTimer: `height: 60px;`
		}
	}
};

export const jackpotCardSizes = {
	// the big jackpot cards that can have inner pool items at the most left of the grid items
	[jackpotGridEnum.MULTIPLE_POOL]: {
		small: {
			width: 336,
			height: 220
		},
		large: {
			width: 510,
			height: 336
		}
	},
	[jackpotGridEnum.SIMPLE]: {
		small: {
			width: 336,
			height: 220
		},
		large: {
			width: 510,
			height: 336
		}
	}
};
